import { Vector3 } from 'three';

const _va = new Vector3();
/**
 * Check if two vectors are in the same direction
 */
export const vectorsInSameDirection = (v1: Vector3, v2: Vector3) => {
  _va.copy(v1).cross(v2);
  return _va.length() < Number.EPSILON; // using epsilon instead of zero to account JS floating point precision limits
};
